import { toSnake } from '../../common'
import type { Article } from '../types'

type UpsertSubmitResult =
  | { layoutableId: number | string; layoutableType: string; formData: FormData; successAlertBody?: string }
  | {
      layoutableId: number | string
      layoutableType: string
      articleId: string
      formData: FormData
      successAlertBody?: string
    }

export interface UpsertParams {
  layoutableId: number | string
  layoutableType: string
  layoutableLockVersion?: unknown
  article: Article
  loadedBinaryFile?: { blob: Blob; name: string }
  deleteFile?: boolean
  auxiliaryLine?: Article['auxiliaryLine'] | null
  successAlertBody?: string
  replaceFile?: boolean
  applyRelationTypeToSiblings?: boolean
  [key: string]: unknown
}

export const getSubmitParamForArticleUpsert = ({
  layoutableId,
  layoutableType,
  layoutableLockVersion,
  article,
  loadedBinaryFile,
  deleteFile,
  auxiliaryLine,
  successAlertBody,
  applyRelationTypeToSiblings,
  ...props
}: UpsertParams): UpsertSubmitResult => {
  // handle replace and delete
  const { auxiliaryLine: _auxiliaryLineFromArticle, ...otherArticleProps } = article
  const { replaceFile: _replaceFile, ...otherProps } = props
  const newArticle: Record<string, unknown> = {
    ...otherArticleProps,
    ...otherProps
  }
  // console.log('getSubmitParamForArticleUpsert', { newArticle, otherProps, otherArticleProps })
  if (auxiliaryLine !== null) {
    newArticle.auxiliaryLine = auxiliaryLine
  }
  const formData = new window.FormData()
  formData.append('article', JSON.stringify(toSnake(newArticle)))
  formData.append('lock_version', String(layoutableLockVersion ?? ''))
  if (applyRelationTypeToSiblings) {
    formData.append('apply_relation_type_to_siblings', 'true')
  }
  if (deleteFile) {
    formData.append('delete_file', 'true')
  } else if (loadedBinaryFile !== undefined) {
    const { blob, name } = loadedBinaryFile
    formData.append('file', blob, name)
  }
  const articleId = newArticle.id as string | undefined
  if (articleId === undefined) {
    return { layoutableId, layoutableType, formData, successAlertBody }
  } else {
    return {
      layoutableId,
      layoutableType,
      articleId,
      formData,
      successAlertBody
    }
  }
}

export const detailOffcanvasTypes = ['headings', 'preambleColumn', 'bodyColumn', 'figures', 'areas', 'templateArticle']

export const layoutMissed = (props: { row: { original: { id: string | number } } }, missedArticles: Set<string>) =>
  missedArticles.has(`article-${props.row.original.id}`)

export const getLayoutableName = (layoutableType: string) => {
  switch (layoutableType) {
    case 'Page':
      return '紙面'
    case 'SubLayout':
      return '小組'
    default:
      return ''
  }
}
